import { useCallback, useId, useRef, useState } from 'react';
import { SvgNames } from '../../../Svg';
import { IInput } from '../Input/input.models';
import { IUsePasswordProps } from './password.models';

export const usePassword = ({ onChange, onFocus, ref }: IUsePasswordProps) => {
  const innerRef = useRef<HTMLInputElement | null>(null);

  const [show, setShow] = useState<boolean>(false);

  const id = useId();

  const svg: SvgNames = show ? 'eye' : 'eyeSlash';

  const type: IInput['type'] = show ? 'text' : 'password';

  const refCallback = useCallback(
    (node: HTMLInputElement) => {
      if (node) {
        innerRef.current = node;

        if (ref) {
          if (typeof ref === 'function') {
            ref(node);
          } else {
            // eslint-disable-next-line no-param-reassign
            ref.current = node;
          }
        }
      }
    },
    [ref]
  );

  const handleFocus = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      onFocus?.(e);
    },
    [onFocus]
  );

  const toggleClick = useCallback(() => {
    setShow((s) => !s);
  }, []);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e);
    },
    [onChange]
  );

  return {
    handleChange,
    handleFocus,
    id,
    refCallback,
    svg,
    toggleClick,
    type,
  };
};

